/**
 * Loading placeholder.
 *
 * Respects `prefers-reduced-motion` through the global rule in index.css, which
 * flattens the pulse rather than removing the placeholder (14.5).
 */
import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/lib/cn'

export function Skeleton({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn('animate-pulse rounded bg-[var(--util-bar-track)]', className)}
      // Decorative: a screen reader should hear the eventual content, not the wait.
      aria-hidden
      {...props}
    />
  )
}
